import config from '@/config/api/config';

export default (ctx, inject) => {
  ctx.$api = config;
  inject('api', config);
};
